export default "__VITE_ASSET__ChkeiIN7__"